<template>
    <v-app dark>
        <v-app-bar class="barra" dark app dense fixed>
            <v-app-bar-nav-icon @click="drawerState = !drawerState"
            ></v-app-bar-nav-icon>

            <v-img
                class="mx-3 mt-3"
                :src="require('@/assets/logo-origo-white.png')"
                max-height="80"
                max-width="120"
            ></v-img>
            <v-toolbar-title></v-toolbar-title>
            <v-spacer></v-spacer>
            Olá {{ account }}
            <v-btn icon @click="sair()">
                <v-icon>mdi-logout</v-icon>
            </v-btn>
        </v-app-bar>

        <div class="corner-ribbon" v-if="isDevHml">{{ message }}</div>

        <v-navigation-drawer v-model="drawerState" class="primary" app temporary clipped
                             :style="{ top: $vuetify.application.top + 'px', zIndex: 4, width: '300px' }">

            <menubar></menubar>
        </v-navigation-drawer>
        <v-main>
            <v-container fluid>
                <v-alert v-if="estornos.length > 0 && $route.meta.modulo == 'Balanço Energético'" type="error" dense>Estornos provenientes do Balanço Financeiro</v-alert>
                <v-alert
                    outlined
                    type="error"
                    prominent
                    dismissible
                    transition="scale-transition"
                    v-if="estornos.length > 0 && $route.meta.modulo == 'Balanço Energético'"
                >
                    <v-btn v-for="estorno in estornos"
                           class="mr-1"
                           :key="estorno.referencia"
                        outlined
                           @click="irParar('visualizar-balanco-referencia-lista', { referencia: estorno.referencia, consorcio:'Todos'})"
                        color="red"
                    ><b>Ref:</b> {{ estorno.referencia | formataDataMesAno }} - <b>Qtd</b>: {{estorno.contador}}</v-btn>
                </v-alert>
                <flash-message class="myCustomClass" transitionName="fade-transition"></flash-message>

                <transition name="fade-transition">
                    <router-view></router-view>
                </transition>
            </v-container>
        </v-main>
        <v-overlay :value="spinnerState" style="z-index: 10000">
            <v-progress-circular
                :size="150"
                :width="15"
                color="secondary"
                indeterminate
            ></v-progress-circular>
        </v-overlay>
        <notifications group="foo"/>
    </v-app>
</template>

<script>
import {logout} from '../plugins/axios'
import menubar from "../components/menubar";

export default {
    name: "app",
    components: {menubar},
    data: function () {
        return {
            message: '',
            usuario: {
                nome: ''
            },
            estornos: [],
        }
    },
    computed: {
        drawerState: {
            get() {
                return this.$store.getters['drawer/drawerState'];
            },
            set(v) {
                return this.$store.commit('drawer/toggleDrawerState', v)
            }
        },
        spinnerState: {
            get() {
                return this.$store.getters['spinner/spinnerState'];
            },
        },
        isDevHml() {
            if (process.env.NODE_ENV == 'local') {
                this.message = 'LOCAL';
                return true;
            }

            if (process.env.NODE_ENV == 'dev') {
                this.message = 'DEV';
                return true;
            }

            if (process.env.NODE_ENV == 'homologation') {
                this.message = 'HML';
                return true;
            }

            return false;
        },
        account() {

            if (localStorage.getItem('account')) {
                const account = JSON.parse(localStorage.getItem('account'));

                return account.name;
            }
            return '';
        }

    },
    mounted() {
        this.getDados();
    },
    watch: {
        $route(to, from) {
            this.getEstornos();
        }
    },
    methods: {
        irParar(url, params) {
            this.$router.push({name: url, params: params, query: {
                    estornado: 1
                }}, () => {
                window.location.reload();
            })
        },
        sair() {
            if (confirm('Você deseja sair?')) {
                logout();
            }
        },
        getDados() {
            const vm = this;
        },
        getEstornos(){
          const vm = this

          vm.$store.dispatch('balanco/getEstornosCount')
              .then(function (response) {
                vm.estornos = response.data
              })
                .catch(function (error) {
                    console.log(error)
                })
        }
    }
}

</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900");
@import url("https://cdn.jsdelivr.net/npm/@mdi/font@6.x/css/materialdesignicons.min.css");

.barra {
    background: linear-gradient(135deg, #4b1441, #209a90) !important;
}

.v-list-item__title {
    color: #fff !important;
}

.corner-ribbon {
    width: 200px;
    background: #e43;
    position: fixed;
    top: 25px;
    left: -50px;
    text-align: center;
    line-height: 50px;
    letter-spacing: 1px;
    color: #f0f0f0;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    z-index: 99999;
    opacity: 0.5;
    pointer-events: none;
}


</style>



// WEBPACK FOOTER //
// src/layouts/app.vue